<script setup lang="ts">
  import { computed } from 'vue'

  import { Routes } from '@/const/Routes'
  import { useSubjectResource } from '@/composables/useSubjectResource'
  import { useAppRouting } from '@/composables/useAppRouting'

  import Typography from '@/components/common/Typography.vue'
  import { KsIcon } from '@aschehoug/kloss'

  const props = defineProps<{
    contentId: number
    index: number
  }>()
  const { getRouteWithParams } = useAppRouting()
  const { subjectResource, subjectResourceTitle, flytTasks, stepTasks } = useSubjectResource(props.contentId)
  const totalTaskCount = computed(() => flytTasks.value.length + stepTasks.value.length)
</script>

<template>
  <router-link
    v-if="subjectResource"
    :to="getRouteWithParams(Routes.CollectionTask, subjectResource)"
    class="router-link"
  >
    <li class="assignment-list-item">
      <div class="content">
        <div class="number">
          <Typography :font-weight="700">
            {{ index }}
          </Typography>
        </div>

        <div class="info">
          <Typography
            component="h3"
            variant="body"
            :font-weight="700"
          >
            {{ subjectResourceTitle }}
          </Typography>
          <Typography
            v-if="totalTaskCount > 0"
            component="p"
            variant="number-small"
          >
            {{ totalTaskCount }} {{ totalTaskCount === 1 ? "oppgave" : "oppgaver" }}
          </Typography>
        </div>
      </div>

      <div class="arrow">
        <KsIcon id="arrow-right" />
      </div>
    </li>
  </router-link>
</template>

<style scoped lang="scss">
  .assignment-list-item {
    background: var(--color-white);
    border: 1px solid var(--color-gray-20);
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: var(--color-blue-50);

    svg {
      transition: .3s;
    }

    &:hover {
      background: var(--ks-borderhoverfill);
      transition: .3s;

      svg {
        transform: translateX(5px);
        transition: .3s;
      }
    }

    .content {
      display: flex;
      align-items: center;
      gap: 12px;

      .number {
        background: var(--color-orange-20);
        color: var(--color-violet-50);
        border-radius: 50%;
        height: 40px;
        width: 40px;
        align-items: center;
        display: flex;
        justify-content: center;
      }

      .info {
        align-items: center;
        display: block;

        p, h3 {
          margin: 0;
        }
      }
    }
  }

  .router-link {
    text-decoration: none;
  }
</style>
